module.exports = __webpack_public_path__ + "fonts/lato.2fe27d9d.ttf";